export const getRandomAngleDeviation = (angleLimit: number): number => {
    const randomFactor = Math.random() * 2 - 1
    return randomFactor * (angleLimit / 2)
}